// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, ViewChild, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { User } from '../models/user.model';
import { Role } from '../models/role.model';

import { UserEditorComponent } from './user-editor.component';

@Component({
    selector: 'app-edit-user-dialog',
    templateUrl: 'edit-user-dialog.component.html',
    styleUrls: ['edit-user-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditUserDialogComponent
{
    @ViewChild(UserEditorComponent, { static: true })
    editUser!: UserEditorComponent;

    get fullName() : any
    {
        return this.data.user ? { name: this.data.user.fullName } : null;
    }

    constructor(
        public dialogRef: MatDialogRef<EditUserDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { user: User, roles: Role[] })
    {
    }

    ngAfterViewInit() {
        this.editUser.userSaved$.subscribe(user => this.dialogRef.close(user));
    }

    cancel(): void
    {
        this.dialogRef.close(null);
    }
}
